import { AnimatedNumber } from './AnimatedNumber';

/** One point denomination across balances, stakes, rewards and results. */
export function PointsUnit() {
  return <span className="points-unit">PTS</span>;
}

export function PointsAmount({ value }: { value: string | number }) {
  return (
    <span className="points-amount">
      <AnimatedNumber value={value} /> <PointsUnit />
    </span>
  );
}

/** Keep explanatory copy and server messages intact while styling their unit. */
export function PointsText({ text }: { text: string }) {
  return text
    .split(/(\bpts\b)/gi)
    .map((part, i) =>
      /^pts$/i.test(part) ? (
        <PointsUnit key={i} />
      ) : (
        <AnimatedNumber key={i} value={part} />
      ),
    );
}
